import React from 'react';
import './About.css';

import { Button, Heading } from '../../../components';
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, description, points, image, button } = about;

  return (
    <section className="about">

      {/* About Content */}
      <div className="content">

        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        <p>{description}</p>

        {/* Key Features */}
        <ul className="about-features">
          {points.map((point, index) => (
            <li key={index}>
              <div className='icon'>{point.icon}</div>
              <span>{point.title}</span>
            </li>
          ))}
        </ul>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>

      {/* About Image */}
      <div className="image">

        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
          <img src={image.src2} alt={image.src2} />
        </div>

        <div className='sub-image two'>
          <img src={image.src3} alt={image.src3} />
          <img src={image.src4} alt={image.src4} />
        </div>

      </div>

    </section>
  );
}

export default About;